import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useTranslation } from 'react-i18next';
import HotelRoomCategory from './hotel_roomcategory';

const HotelRoomCategories = ({ blok, hotel, season }) => {
  const { t } = useTranslation(['hotel']);

  if (hotel.roomCategories?.length > 0) {
    return (
      <div
        {...storyblokEditable(blok)}
        key={blok._uid}
        id="room"
        className="col-span-12"
      >
        <div className="grid max-w-screen-xl w-full gap-4 grid-cols-12 mx-auto  pt-12">
          <div className="w-full col-span-12 px-4 md:px-8 ">
            <h1>
              {t('Rooms at ')}
              {hotel.name}
            </h1>
          </div>
          {hotel.roomCategories
            ?.filter((c) => c.id !== 'FLER')
            .map((cat, index) => {
              return (
                <HotelRoomCategory
                  category={cat}
                  index={index}
                  hotel={hotel}
                  season={season}
                  key={cat.id}
                />
              );
            })}
        </div>
      </div>
    );
  } else return null;
};

export default HotelRoomCategories;
